module.exports = __webpack_public_path__ + "static/img/Combined@2x.1f78edd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktbConsociation/Combined@2x.png
// module id = Zd7x
// module chunks = 69